module.exports = __webpack_public_path__ + "img/qrcode_north.23bd2692.png";